import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { CONTACT } from "@/i18n/translations";
import Logo from "@/components/Logo";

const PRIVACY = [
  ["Responsable du traitement", `Le présent site est édité par A&K Atelier (Artisan Créateur de Décors en Plâtre). Pour toute question relative à vos données, contactez-nous à ${CONTACT.email} ou au ${CONTACT.phoneDisplay}.`],
  ["Données collectées", "Nous collectons uniquement les données que vous nous transmettez volontairement : via le formulaire de contact (nom, téléphone, e-mail, message) et, si vous créez un compte, votre nom et votre adresse e-mail. Les avis que vous publiez (texte, note et photos) sont visibles publiquement."],
  ["Finalités", "Vos données sont utilisées pour répondre à vos demandes de devis, gérer votre compte, publier vos avis et améliorer nos services. Elles ne sont jamais vendues à des tiers."],
  ["Conservation", "Les demandes de contact sont conservées le temps nécessaire au traitement de votre demande. Les comptes et avis sont conservés tant que vous ne demandez pas leur suppression."],
  ["Cookies", "Nous utilisons des cookies techniques nécessaires au fonctionnement du site ainsi que, avec votre consentement, des cookies de mesure d'audience. Vous pouvez accepter ou refuser via le bandeau de consentement."],
  ["Vos droits", `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données. Pour exercer ces droits, écrivez-nous à ${CONTACT.email}.`],
];

const LEGAL = [
  ["Éditeur du site", "A&K Atelier — Artisan Créateur de Décors en Plâtre."],
  ["Contact", `Téléphone : ${CONTACT.phoneDisplay} — E-mail : ${CONTACT.email}`],
  ["Activité", "Création, fabrication et pose d'éléments décoratifs en plâtre : corniches, rosaces, colonnes, moulures, panneaux et restauration."],
  ["Hébergement", "Le site est hébergé sur une infrastructure cloud sécurisée (accessible en HTTPS)."],
  ["Propriété intellectuelle", "L'ensemble des contenus (textes, photographies, vidéos, logo) est la propriété d'A&K Atelier et ne peut être reproduit sans autorisation."],
];

const LegalPage = ({ variant = "privacy" }) => {
  const { t } = useLang();
  const isPrivacy = variant === "privacy";
  const sections = isPrivacy ? PRIVACY : LEGAL;
  const title = isPrivacy ? t("legal.privacyTitle") : t("legal.legalTitle");

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Logo size={40} />
          <span className="font-serif text-xl">
            <span className="gold-gradient-text">A&amp;K</span> Atelier
          </span>
        </Link>
        <Link to="/" className="text-sm text-muted-foreground hover:text-gold flex items-center gap-1.5 font-sans">
          <ArrowLeft size={15} /> {t("legal.back")}
        </Link>
      </header>

      <div className="max-w-3xl mx-auto px-6 md:px-10 py-14">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground font-sans">{t("legal.updated")}: 06/2026</p>
        <div className="mt-10 space-y-8">
          {sections.map(([heading, body]) => (
            <section key={heading}>
              <h2 className="font-serif text-2xl text-gold">{heading}</h2>
              <p className="mt-2 text-muted-foreground font-sans leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
